import React, { PropsWithChildren } from 'react';
import {
    Text,
    TextProps,
    Badge,
    Group,
    BadgeProps,
    Flex,
    Skeleton,
} from '@landr/maestro';

interface TitleProps extends TextProps {
    isMobile?: boolean;
    badgeProps?: BadgeProps & React.HTMLAttributes<HTMLDivElement>;
    isLoading?: boolean;
}

const Title: React.FC<PropsWithChildren<TitleProps>> = ({
    children,
    isMobile = false,
    badgeProps,
    isLoading = false,
}) => (
    <>
        {isLoading && (
            <Flex mt="sm" mb="xs">
                <Skeleton height="30px" width="60%" />
            </Flex>
        )}
        {!isLoading && (
            <Group
                direction={isMobile ? 'vertical-reverse' : 'horizontal'}
                gap={{
                    base: 'xs',
                    md: 'md',
                }}
                justifyContent={{
                    base: 'center',
                    md: 'normal',
                }}
            >
                <Group.Item>
                    <Text
                        as="h1"
                        fontWeight="bold"
                        textStyle={{ base: 'title-sm', md: 'title-lg' }}
                        nbOfLines={1}
                        paddingBottom="xs"
                    >
                        {children}
                    </Text>
                </Group.Item>

                {badgeProps && (
                    <Group.Item alignSelf="center">
                        <Badge {...badgeProps} />
                    </Group.Item>
                )}
            </Group>
        )}
    </>
);

Title.displayName = 'PageHeader.Title';

export default Title;
